import React from "react";
import * as d3 from "d3";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import Icon from "material-ui/Icon";
import STWiremapGenerator from "../../../../common/stwiremapGenerator";

class STWiremapDiagram extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wmContainerWidth: 320,
      wmLineWidth: 10,
      colors: {
        Standard: {
          "1": "#000000", //BLACK
          "2": "#000000", //BLACK
          "3": "#000000", //BLACK
          "4": "#000000", //BLACK
          "5": "#000000", //BLACK
          "6": "#000000", //BLACK
          "7": "#000000", //BLACK
          "8": "#000000", //BLACK
          "9": "#000000", //BLACK
          short: "#FF0000" //RED
        },
        "568A": {
          "1": "#648E28", //GREEN
          "2": "#648E28", //GREEN
          "3": "#FFA500", //ORANGE
          "4": "#4267B2", //BLUE
          "5": "#4267B2", //BLUE
          "6": "#FFA500", //ORANGE
          "7": "#74412F", //BROWN
          "8": "#74412F", //BROWN
          "9": "#000000", //BLACK
          short: "#FF0000" //RED
        },
        "568B": {
          "1": "#FFA500", //ORANGE
          "2": "#FFA500", //ORANGE
          "3": "#648E28", //GREEN
          "4": "#4267B2", //BLUE
          "5": "#4267B2", //BLUE
          "6": "#648E28", //GREEN
          "7": "#74412F", //BROWN
          "8": "#74412F", //BROWN
          "9": "#000000", //BLACK
          short: "#FF0000" //RED
        },
        TERA: {
          "1": "#4267B2", //BLUE
          "2": "#4267B2", //BLUE
          "3": "#FFA500", //ORANGE
          "4": "#74412F", //BROWN
          "5": "#74412F", //BROWN
          "6": "#FFA500", //ORANGE
          "7": "#648E28", //GREEN
          "8": "#648E28", //GREEN
          "9": "#000000", //BLACK
          short: "#FF0000" //RED
        },
        USOC: {
          "1": "#74412F", //BROWN
          "2": "#648E28", //GREEN
          "3": "#FFA500", //ORANGE
          "4": "#4267B2", //BLUE
          "5": "#4267B2", //BLUE
          "6": "#FFA500", //ORANGE
          "7": "#648E28", //GREEN
          "8": "#74412F", //BROWN
          "9": "#000000", //BLACK
          short: "#FF0000" //RED
        }
      }
    };
  }
  handleCheckboxChange = e => {
    this.props.onCheckBoxChange(e);
  };
  render() {
    const {
      translate,
      classes,
      wiremapStandard,
      chartMeasurementUnit,
      data,
      isAdd,
      isEdit
    } = this.props;

    if (data) {
      chartMeasurementUnit &&
        STWiremapGenerator.setChartMeasurementUnit(chartMeasurementUnit);
      translate && STWiremapGenerator.setTranslate(translate);

      let { wmContainerWidth, wmLineWidth } = this.state;
      let colors = wiremapStandard
        ? this.state.colors[wiremapStandard]
        : this.state.colors["568B"];
      let wmLineGap = wmLineWidth * 2;
      let wmMarginHor = wmLineWidth * 2;
      let wmHeadTailsWidth = wmLineWidth * 0; //FIRST AND LAST DASH WIDTH
      let wmContainerHeight = (wmLineWidth + wmLineGap) * 9 + wmLineGap;

      //Texts
      let texts = ["1", "2", "3", "4", "5", "6", "7", "8", "S"];

      let textsData = STWiremapGenerator.generateTexts(
        texts,
        wmContainerWidth,
        wmMarginHor,
        wmLineGap,
        wmLineWidth
      );

      let checkboxData = STWiremapGenerator.generateCheckBox(
        texts,
        wmContainerWidth,
        wmMarginHor,
        wmLineGap,
        wmLineWidth
      );

      //Head and Tails
      let allHeadTailsData = STWiremapGenerator.generateHeadTail(
        data,
        wmContainerWidth,
        wmMarginHor,
        wmHeadTailsWidth,
        wmLineGap,
        wmLineWidth
      );

      //Lines
      let allLinesData = STWiremapGenerator.generateLines(
        data,
        wmContainerWidth,
        wmMarginHor + wmHeadTailsWidth,
        wmLineGap,
        wmLineWidth
      );
      let linesData = allLinesData.lines;
      let shortLinesData = allLinesData.shortlines;
      let openLinesData = allLinesData.openlines;

      let lineFunction = d3
        .line()
        .x(function(d) {
          return d.x;
        })
        .y(function(d) {
          return d.y;
        })
        .curve(d3.curveMonotoneX);

      return (
        <div id="wmContainer" ref="wmContainer" className={classes.root}>
          <svg width={wmContainerWidth} height={wmContainerHeight}>
            <defs>
              <marker
                id="ShortMarker"
                markerWidth={wmLineWidth / 3}
                markerHeight={wmLineWidth / 3}
                refX={wmLineWidth / 6}
                refY={wmLineWidth / 6}
              >
                <circle
                  cx={wmLineWidth / 6}
                  cy={wmLineWidth / 6}
                  r={wmLineWidth / 12}
                  style={{ stroke: colors.short, fill: colors.short }}
                />
              </marker>
            </defs>
            {textsData.map((d, i) => {
              return (
                <g width="20" height="20">
                  <ellipse
                    cx={d.x + 5}
                    cy={d.y - 5}
                    rx="10"
                    ry="8"
                    stroke="#4267B2"
                    stroke-width="3"
                    fill="#4267B2"
                  />
                  {/* <circle
                    cx={d.x + 5}
                    cy={d.y - 5}
                    r="8"
                    stroke="#4267B2"
                    stroke-width="3"
                    fill="#4267B2"
                  /> */}
                  <text
                    key={`wiremapdia-t-${i}`}
                    x={d.x + 3}
                    y={d.y - 1}
                    text-anchor="middle"
                    fontSize={d.fontSize - 3}
                    fill="white"
                    //fontWeight="bold"
                    textAnchor={d.textAnchor}
                  >
                    {d.text}
                  </text>
                </g>
              );
            })}
            {allHeadTailsData.headlines.map((d, i) => {
              return (
                <path
                  key={`wiremapdia-l-${i}`}
                  d={lineFunction(d.line)}
                  stroke={colors[d.pin]}
                  strokeWidth={wmLineWidth}
                  fill="none"
                  style={d.dash ? { strokeDasharray: "20, 6" } : {}}
                ></path>
              );
            })}
            {linesData.map((d, i) => {
              return (
                <path
                  key={`wiremapdia-l-${i}`}
                  d={lineFunction(d.line)}
                  stroke={d.lineColor ? d.lineColor : colors[d.pin]}
                  strokeWidth={d.lineWidth ? d.lineWidth : wmLineWidth}
                  fill="none"
                  style={d.dash ? { strokeDasharray: "20, 6" } : {}}
                ></path>
              );
            })}
            {allHeadTailsData.taillines.map((d, i) => {
              return (
                <g>
                  <path
                    key={`wiremapdia-l-${i}`}
                    d={lineFunction(d.line)}
                    stroke={colors[d.pin]}
                    strokeWidth={wmLineWidth}
                    fill="none"
                    style={d.dash ? { strokeDasharray: "20, 6" } : {}}
                  ></path>
                </g>
              );
            })}

            {/* {isAdd == true
              ? checkboxData.map((d, i) => {
                  return (
                    <foreignObject
                      width="10%"
                      height="10%"
                      x={d.x - 15}
                      y={d.y - 12}
                      textAnchor="end"
                    >
                      <input
                        id={i}
                        type={i == 8 ? "hidden" : "checkbox"}
                        //checked={data.Details[i].IsThru}
                        onChange={this.handleCheckboxChange}
                      />
                    </foreignObject>
                  );
                })
              : null}
            {isEdit == true
              ? checkboxData.map((d, i) => {
                  return (
                    <foreignObject
                      width="10%"
                      height="10%"
                      x={d.x - 15}
                      y={d.y - 12}
                      textAnchor="end"
                    >
                      <input
                        id={i}
                        type={i == 8 ? "hidden" : "checkbox"}
                        checked={data.Details[i].IsThru}
                        onChange={this.handleCheckboxChange}
                      />
                    </foreignObject>
                  );
                })
              : null} */}
            {shortLinesData.map((d, i) => {
              return (
                <path
                  key={`wiremapdia-s-${i}`}
                  d={lineFunction(d.line)}
                  stroke={colors.short}
                  strokeWidth={wmLineWidth / 3}
                  fill="none"
                  markerStart={d.marker ? "url(#ShortMarker)" : ""}
                  markerEnd={d.marker ? "url(#ShortMarker)" : ""}
                ></path>
              );
            })}
            {openLinesData.map((d, i) => {
              return (
                <path
                  key={`wiremapdia-o-${i}`}
                  d={lineFunction(d.line)}
                  stroke="black"
                  strokeWidth={wmLineWidth / 3}
                  fill="none"
                ></path>
              );
            })}
          </svg>
        </div>
      );
    } else {
      return (
        <div id="wmContainer" ref="wmContainer" className={classes.root}></div>
      );
    }
  }

  resizeWiremap() {
    if (this.refs && this.refs.wmContainer) {
      let containerWidth = this.refs.wmContainer.offsetWidth;
      this.setState({
        wmContainerWidth: containerWidth
      });
    }
  }

  componentDidMount() {
    // this.resizeWiremap();
    // window.addEventListener("resize", this.resizeWiremap.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeWiremap.bind(this));
  }
}

export default withStyles(styles)(STWiremapDiagram);



// WEBPACK FOOTER //
// ./src/components/subtestsetting/common/stdiagram/index.js